import React, {useRef, useState} from 'react';
import Navigation from '@header/scripts/components/navigation/Navigation.jsx';
import HeaderCart from '@header/scripts/components/HeaderCart.jsx';
import WishlistNavigationHeader from '@wishlist/components/WishlistNavigationHeader.jsx';
import User from '@header/scripts/components/user/User.jsx';
import SearchField from '@header/scripts/components/search/SearchField.jsx';
import HeaderLogo from '@header/scripts/components/HeaderLogo.jsx';

export default function Header({
    rootUrl,
    navigation,
    wishlist,
    cart,
    user,
    deviceType,
    currentPage,
    currentShopId,
    search,
}) {
    const [logoHidden, setLogoHidden] = useState(false);

    const headerRef = useRef();

    const hideLogo = () => {
        setLogoHidden(true);
    };
    const showLogo = () => {
        setLogoHidden(false);
    };

    return (
        <div className="header__inner-wrapper" ref={headerRef}>
            <div className="header__left">
                {!logoHidden && <HeaderLogo rootUrl={rootUrl} />}

                <Navigation
                    navigation={navigation}
                    currentPage={currentPage}
                    currentShopId={currentShopId}
                    headerRef={headerRef}
                />
            </div>
            <div className="header__right">
                <SearchField
                    searchUrl={search.url}
                    noResultsFound={search.noResultsFound}
                    hideLogo={hideLogo}
                    showLogo={showLogo}
                />

                <User user={user} deviceType={deviceType} />

                <WishlistNavigationHeader
                    wishlistUrl={wishlist.url}
                    wishlistCount={wishlist.count}
                    deviceType={deviceType}
                    texts={wishlist.texts}
                    enabled={wishlist.enabled}
                />
                <HeaderCart url={cart.url} title={cart.title} deviceType={deviceType} />
            </div>
        </div>
    );
}
